import { render } from "./DropdownDelegations.vue?vue&type=template&id=a4303668"
import script from "./DropdownDelegations.vue?vue&type=script&lang=ts"
export * from "./DropdownDelegations.vue?vue&type=script&lang=ts"
script.render = render

export default script